import { Icon } from '@chakra-ui/react';

const PhoneIcon = (props) => (
    <Icon
        width="19px"
        height="33px"
        viewBox="0 0 19 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M7.3125 1.1875H4.03125C3.16101 1.1875 2.32641 1.5332 1.71106 2.14856C1.0957 2.76391 0.75 3.59851 0.75 4.46875V28.5313C0.75 29.4015 1.0957 30.2361 1.71106 30.8514C2.32641 31.4668 3.16101 31.8125 4.03125 31.8125H14.9688C15.839 31.8125 16.6736 31.4668 17.2889 30.8514C17.9043 30.2361 18.25 29.4015 18.25 28.5313V4.46875C18.25 3.59851 17.9043 2.76391 17.2889 2.14856C16.6736 1.5332 15.839 1.1875 14.9688 1.1875H11.6875M7.3125 1.1875V3.375H11.6875V1.1875M7.3125 1.1875H11.6875M7.3125 28.5313H11.6875" stroke="#8E8F8C" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default PhoneIcon;
